/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-11-16 11:41:29
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-11-16 15:44:57
 */
import type { Effect, Reducer } from 'umi'
import { getAccountlist } from '@/services/system/account'

export interface StateType {
  accountMap: any
}

export interface KanbanModelType {
  namespace: string
  state: StateType
  effects: {
    fetchAccountList: Effect
  }
  reducers: {
    saveAccountMap: Reducer<StateType>
  }
}

const KanbanModel: KanbanModelType = {
  namespace: 'topic',

  state: {
    accountMap: {}
  },

  effects: {
    *fetchAccountList({ payload }, { call, put }) {
      const response = yield call(getAccountlist, {
        page: 1,
        page_size: 999,
        ...payload
      })
      yield put({
        type: 'saveAccountMap',
        payload: response.data.list || []
      })
    }
  },

  reducers: {
    saveAccountMap(state, { payload }) {
      const map = {}
      payload.forEach((li: any) => {
        map[li.id] = li
      })
      return {
        ...state,
        accountMap: map
      }
    }
  }
}

export default KanbanModel
